module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"addFtpConnection_Header":"Nuova attività di sincronizzazione","editFtpConnectionDialog_Header":"Modifica l\u0027attività di sincronizzazione","formAddEditSynchronizationTasks":{"SyncFtpFolder":"Cartella remota","FtpConnectionId":"Connessione FTP","EventId":"Evento","TaskName":"Nome"}}}')
  delete Component.options._Ctor
}
